import React, { useState, useEffect } from "react";

const Select = (props) => {
  const [value, setValue] = useState(props.value);

  // Handle onChange event
  const onChangeHandler = (event) => {
    setValue(event.target.value);
    if (props.onChange) props.onChange(event);
  };

  useEffect(() => {
    setValue(props.value);
  }, [props.value]);

  return (
    <div className="d-flex flex-column justify-content-start">
      <fieldset className={props.className}>
        <legend>
          <span>{props.title}</span>
        </legend>
        <select
          className={`settings_select_field ${
            props.selectClass ? props.selectClass : ""
          }`}
          value={value}
          name={props.name}
          onChange={(event) => onChangeHandler(event)}
          disabled={props.disabled}
        >
          {props.children}
        </select>
      </fieldset>
      {props.error && (
        <small className="text-danger ml-1" style={{ fontSize: "11px", textAlign: "left" }}>
          *{props.error}
        </small>
      )}
    </div>
  );
};

export default Select;
